import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login'),
    meta: {
      alert: {
        tips: false,
      }
    },
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/home'),
    meta: {
      alert: {
        tips: false,
      }
    },
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/home.vue'),
        meta: {
          title: '首页',
          alert: {
            tips: false,
          }
        },
      },
      {
        /**认证管理 */
        path: '/realNameAuthentication',
        name: 'realNameAuthentication',
        component: () => import('../views/home/authentication/'),
        meta: {
          title: '认证管理',
          alert: {
            tips: false,
          }
        },
        children: [
          {
            /**实名认证 */
            path: '/realNameAuthentication',
            name: 'realNameAuthentication',
            component: () => import('../views/home/authentication/realNameAuthentication/'),
            meta: {
              title: '实名认证',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**企业认证 */
            path: '/enterpriseAuthentication',
            name: 'enterpriseAuthentication',
            component: () => import('../views/home/authentication/enterpriseAuthentication/'),
            meta: {
              title: '企业认证',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**押金认证 */
            path: '/depositAuthentication',
            name: 'depositAuthentication',
            component: () => import('../views/home/authentication/depositAuthentication/'),
            meta: {
              title: '押金认证',
              keepalive: true,
              alert: {
                tips: true,
                info: '不能关闭哦'
              }
            },
          },
        ]
      },
      {
        /**世界聊天 */
        path: '/worldChat',
        name: 'worldChat',
        component: () => import('../views/home/worldChat/'),
        meta: {
          title: '世界聊天',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**用户管理 */
        path: '/userManage',
        name: 'userManage',
        component: () => import('../views/home/userManage/'),
        meta: {
          title: '用户管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**用户详情 */
        path: '/userInfo',
        name: 'userInfo',
        component: () => import('../views/home/userManage/userInfo/'),
        meta: {
          title: '用户详情',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**客服管理 */
        path: '/customerManage',
        name: 'customerManage',
        component: () => import('../views/home/customerManage/'),
        meta: {
          title: '客服管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**聊天管理 */
        path: '/chatManage',
        name: 'chatManage',
        component: () => import('../views/home/chatManage/'),
        meta: {
          title: '聊天管理',
          alert: {
            tips: false,
          }
        },
        children: [
          {
            /**私聊管理 */
            path: '/privateManage',
            name: 'privateManage',
            component: () => import('../views/home/chatManage/privateManage'),
            meta: {
              title: '私聊管理',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**群聊管理 */
            path: '/groupChatManage',
            name: 'groupChatManage',
            component: () => import('../views/home/chatManage/groupChatManage'),
            meta: {
              title: '群聊管理',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**违规管理 */
            path: '/violationManage',
            name: 'violationManage',
            component: () => import('../views/home/chatManage/violationManage/'),
            meta: {
              title: '违规管理',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
        ]
      },
      {
        /**私聊详情 */
        path: '/privateInfo',
        name: 'privateInfo',
        component: () => import('../views/home/chatManage/privateManage/privateInfo'),
        meta: {
          title: '私聊详情',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**提现管理 */
        path: '/cashOutManage',
        name: 'cashOutManage',
        component: () => import('../views/home/cashOutManage/'),
        meta: {
          title: '提现管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**订单管理 */
        path: '/orderManage',
        name: 'orderManage',
        component: () => import('../views/home/orderManage/'),
        meta: {
          title: '订单管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**押金管理 */
        path: '/depositManage',
        name: 'depositManage',
        component: () => import('../views/home/depositManage/'),
        meta: {
          title: '押金管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**资金池 */
        path: '/capitalLib',
        name: 'capitalLib',
        component: () => import('../views/home/capitalLib/'),
        meta: {
          title: '资金池',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**风险库 */
        path: '/riskLib',
        name: 'riskLib',
        component: () => import('../views/home/riskLib/'),
        meta: {
          title: '风险库',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**流水管理 */
        path: '/streamManage',
        name: 'streamManage',
        component: () => import('../views/home/streamManage/'),
        meta: {
          title: '流水管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**活动管理 */
        path: '/activityManage',
        name: 'activityManage',
        component: () => import('../views/home/activityManage/'),
        meta: {
          title: '活动管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**权限管理 */
        path: '/powerManage',
        name: '123123',
        component: () => import('../views/home/powerManage/'),
        meta: {
          title: '权限管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
      },
      {
        /**设置管理 */
        path: '/seting',
        name: 'seting',
        component: () => import('../views/home/seting/'),
        meta: {
          title: '设置管理',
          keepalive: false,
          alert: {
            tips: false,
          }
        },
        children: [
          {
            /**地区管理 */
            path: '/regionSeting',
            name: 'regionSeting',
            component: () => import('../views/home/seting/regionSeting'),
            meta: {
              title: '地区管理',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**商品库 */
            path: '/goodsLib',
            name: 'goodsLib',
            component: () => import('../views/home/seting/goodsLib'),
            meta: {
              title: '商品库',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**认证奖励 */
            path: '/authReward',
            name: 'authReward',
            component: () => import('../views/home/seting/authReward'),
            meta: {
              title: '认证奖励',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**支付设置 */
            path: '/paySet',
            name: 'paySet',
            component: () => import('../views/home/seting/paySet'),
            meta: {
              title: '支付设置',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          },
          {
            /**app自定义 */
            path: '/appCustom',
            name: 'appCustom',
            component: () => import('../views/home/seting/appCustom'),
            meta: {
              title: 'app自定义',
              keepalive: false,
              alert: {
                tips: false,
              }
            },
          }
        ]
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   to.meta.keepalive = false;
//   console.log(to, from);
//   if (from.meta.alert && from.meta.alert.tips) from.meta.keepalive = true;
//   next()
//   NProgress.start()
//   setTimeout(() => {
//     next()
//   }, 500);
// })

// router.afterEach(() => {
//   NProgress.done()
// })

export default router
